import React from 'react'
import {type ImageStyle} from 'react-native'
import Svg, {
  Defs,
  LinearGradient,
  Path,
  type PathProps,
  Stop,
  type SvgProps,
} from 'react-native-svg'
import {Image} from 'expo-image'

import {useKawaiiMode} from '#/state/preferences/kawaii'
import {flatten, useTheme} from '#/alf'

const ratio = 57 / 64

type Props = {
  fill?: PathProps['fill']
  style?: ImageStyle
} & Omit<SvgProps, 'style'>

export const Logo = React.forwardRef(function LogoImpl(props: Props, ref) {
  const t = useTheme()
  const {fill, ...rest} = props
  const styles = flatten(props.style)
  // @ts-ignore it's fiiiiine
  const size = parseInt(rest.width || 32, 10)

  const isKawaii = useKawaiiMode()

  if (isKawaii) {
    return (
      <Image
        source={
          size > 100
            ? require('../../../assets/kawaii.png')
            : require('../../../assets/kawaii_smol.png')
        }
        accessibilityLabel="SHXRE"
        accessibilityHint=""
        accessibilityIgnoresInvertColors
        style={[{height: size, aspectRatio: 1.4}]}
      />
    )
  }

  // Use SHXRE logo image
  // IMPORTANT: You must add assets/shxre-logo.png for this to work
  // If the file doesn't exist, the build will fail - see LOGO_UPDATE.md for instructions
  return (
    <Image
      // @ts-ignore
      ref={ref}
      source={require('../../../assets/shxre-logo.png')}
      accessibilityLabel="SHXRE"
      accessibilityHint=""
      accessibilityIgnoresInvertColors
      style={[{width: size, height: size, resizeMode: 'contain'}, styles]}
      {...rest}
    />
  )
})
